

















import { Component, Prop, Vue } from 'vue-property-decorator';

export enum FloatMenuPosition {
  Left = 'float-menu--left-position',
  Right = 'float-menu--right-position',
  Center = 'float-menu--center-position',
}

@Component
export default class FloatMenu extends Vue {
  @Prop({ default: FloatMenuPosition.Center }) private position!: FloatMenuPosition;


  private isShow: boolean = false;


  private setIsShow(value: boolean) {
      this.isShow = value;
  }

}
